import { CustomError } from 'utils/customError'

export class InternalServerError extends CustomError {
  constructor(apiPath: string, originalError: any) {
    let title = 'Terjadi kendala sistem'
    let description = 'Silakan coba lagi dalam beberapa saat.'
    super({ title, description, apiPath, originalError })
  }
}
export class NetworkError extends CustomError {
  constructor(apiPath: string, originalError: any) {
    let title = 'Tidak ada koneksi internet'
    let description =
      'Pastikan koneksi WiFi atau kuota internet Anda aktif, lalu coba lagi.'
    super({ title, description, apiPath, originalError })
  }
}
export class ForbiddenError extends CustomError {
  constructor(apiPath: string, originalError: any) {
    const title = 'Halaman tidak bisa dibuka'
    const description =
      'Cek tautan Anda, atau gunakan akun belajar.id/madrasah.kemenag.go.id. Jika masih kesulitan, hubungi bantuan.'
    super({ title, description, apiPath, originalError })
  }
}
